import type { ContentBankListItem } from '@/types/apis/ContentBank';
import type { ClassValue } from 'clsx';

import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { Button } from '../ui/button';

import useTranslation from '@/hooks/useTranslation';
import { cn } from '@/lib/utils';
import routes from '@/statics/routes';

type Props = {
  className?: ClassValue;
  content: ContentBankListItem;
};

const ContentBankCard: React.FC<Props> = ({ className, content }) => {
  const { t } = useTranslation('components.contentBankCard');
  const imageUrl = content.preview_image || '';

  return (
    <div
      className={cn(
        'w-full relative aspect-[53/50] rounded-2xl overflow-hidden',
        className
      )}
    >
      {imageUrl && (
        <Image
          src={imageUrl}
          alt={content.title || 'Content preview'}
          fill
          sizes="(max-width: 768px) 100vw, 300px"
          className="object-cover"
          priority={false}
        />
      )}

      <Link href={routes.content.href(content.id)}>
        <div className="h-full w-full right-0 absolute bottom-0 bg-linear-gradient-2" />
        {content.title && (
          <div className="h-full w-full flex justify-center items-center p-1 pb-9">
            <p className="text-xs text-white font-bold text-center z-10 line-clamp-4">
              {content.title}
            </p>
          </div>
        )}
        <div className="absolute bottom-0 right-0 z-10 w-full p-1">
          <Button
            variant="secondary"
            className="w-full hover:bg-opacity-100"
            size="sm"
          >
            {t('details')}
          </Button>
        </div>
      </Link>
    </div>
  );
};

export default ContentBankCard;
